import type { RecentListItem } from './recent-values-types'

function parseList(raw: string | null): RecentListItem[] {
  if (raw == null || raw === '') return []
  try {
    const parsed = JSON.parse(raw) as unknown
    if (!Array.isArray(parsed)) return []
    return parsed.filter(
      (v): v is RecentListItem =>
        typeof v === 'string' || (typeof v === 'number' && Number.isFinite(v))
    )
  } catch {
    return []
  }
}

export function loadRecentValuesFromLocalStorage(storageKey: string): RecentListItem[] {
  if (typeof window === 'undefined' || !storageKey) return []
  return parseList(window.localStorage.getItem(storageKey))
}

export function saveRecentValuesToLocalStorage(
  storageKey: string,
  values: RecentListItem[]
): void {
  if (typeof window === 'undefined' || !storageKey) return
  window.localStorage.setItem(storageKey, JSON.stringify(values))
}
